import { SvgIcon } from '@mui/material';

export default function PictureIcon(props: any) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 19.4 17.62"
      style={{ width: `19px`, height: `18px`, color: `#383838`, ...props.style }}
    >
      <g>
        <path d="M2.1,17.38a1.91,1.91,0,0,1-1.9-1.9V4.07a1.9,1.9,0,0,1,1.9-1.9h3L6.85.27h5.7l1.75,1.9h3a1.9,1.9,0,0,1,1.9,1.9V15.48a1.92,1.92,0,0,1-1.9,1.9ZM5,9.77A4.75,4.75,0,1,0,9.71,5h0A4.75,4.75,0,0,0,5,9.77Zm1.71,0a3,3,0,1,1,3,3,3,3,0,0,1-3-3Z" />
      </g>
    </SvgIcon>
  );
}
